<template>
	<section class="position-relative z-index-2 py-0 mb-n8">
	  <div class="container-fluid position-relative">
		<div class="max-width-1550 bg-dark position-relative rounded-4 overflow-hidden py-6 py-xl-8">
		  <div class="position-absolute top-100 start-50 translate-middle">
			<img src="assets/images/elements/grad-shape/blur-decoration-2.svg" class="opacity-2 blur-9" alt="Grad shape">
		  </div>
	  
		  <div class="container position-relative" data-bs-theme="dark">
			<div class="row align-items-center">
			  <div class="col-lg-5 mb-5 mb-lg-0">
				<blockquote class="fs-6 fw-semibold text-white mb-sm-4">
				  {{ $t("quote") }}
				</blockquote>
			  </div>
			  <div class="col-lg-6 ms-auto">
				<h5 class="mb-4 text-center text-md-start">{{ $t("topAuthor") }}</h5>
				<div class="row row-cols-1 row-cols-sm-2 row-cols-md-3 g-4">
				  <div class="col">
					<div class="card card-body bg-transparent text-center p-0">
					  <div class="avatar avatar-xl mx-auto flex-shrink-0 mb-3">
						<img class="avatar-img rounded-circle" src="assets/images/team/01.jpg" alt="avatar">
					  </div>
					  <h6 class="mb-1"><a href="#">{{ $t("authors.emmaWatson") }}</a></h6>
					  <small>{{ $t("blogsCount") }}: 36</small>
					</div>
				  </div>
	  
				  <div class="col">
					<div class="card card-body bg-transparent text-center p-0">
					  <div class="avatar avatar-xl mx-auto flex-shrink-0 mb-3">
						<img class="avatar-img rounded-circle" src="assets/images/team/02.jpg" alt="avatar">
					  </div>
					  <h6 class="mb-1"><a href="#">{{ $t("authors.allenSmith") }}</a></h6>
					  <small>{{ $t("blogsCount") }}: 25</small>
					</div>
				  </div>
	  
				  <div class="col">
					<div class="card card-body bg-transparent text-center p-0">
					  <div class="avatar avatar-xl mx-auto flex-shrink-0 mb-3">
						<img class="avatar-img rounded-circle" src="assets/images/team/04.jpg" alt="avatar">
					  </div>
					  <h6 class="mb-1"><a href="#">{{ $t("authors.louisFerguson") }}</a></h6>
					  <small>{{ $t("blogsCount") }}: 15</small>
					</div>
				  </div>
				</div>
			  </div>
			</div>
		  </div>
		</div>
	  </div>
	</section>
  </template>
  

<script>
export default {

}
</script>

<style>

</style>